import styled from "styled-components";

import Button from "core/Button";

import Lock from "core/ReusableIcons/Lock";
import Private from "core/ReusableIcons/Private";

import { BorderBottomLinkStyle } from "core/Typography";
import colors from "core/colors";
import { TooltipContainer } from "core/Tooltip/styles";

import { convertPxToRem } from "frontend/components/helpers";

import breakpoints from "core/breakpoints";

//modal button:
export const ModalButtonContainer = styled.div`
    position: absolute;
    top: ${convertPxToRem({ px: 14 })};
    right: ${convertPxToRem({ px: 14 })};
`;

//FooterContent:
export const IconContainer = styled.div`
    ${Lock} {
        width: ${convertPxToRem({ px: 12 })};
        height: ${convertPxToRem({ px: 12 })};
    }

    @media ${breakpoints.browserSupport.ie10And11} {
        position: relative;
        top: ${convertPxToRem({ px: -5 })};
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;

    ${TooltipContainer} {
        width: 100%;
    }
`;

export const ButtonContent = styled.div``; // needed for flexbox

//ChooseKit:
export const KitButton = styled(Button)`
    margin-bottom: ${convertPxToRem({ px: 24 })};

    &:last-of-type {
        margin-bottom: 0;
    }

    ${Private} {
        margin-right: 0;

        &:hover path {
            fill: ${colors.secondary.orca};
        }
    }
`;

//CreateKit:
export const Form = styled.form``;

export const CancelButton = styled.button`
    margin-top: ${convertPxToRem({ px: 16 })};
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    ${BorderBottomLinkStyle}
`;

export const GeneralFormError = styled.div`
    position: absolute;
    z-index: 10000; // same z-index as Modal
    top: ${convertPxToRem({ px: 52 })};
`;
